
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-16343.76 6815.333 17.104 16"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 7184"}},[_c('path',{attrs:{"d":"M-16342.909 6829.133l6.957-12.643a.846.846 0 0 1 1.445 0l6.957 12.643a.961.961 0 0 1-.723 1.445h-13.913c-.632.005-.994-.808-.723-1.445z","data-name":"Path 3462","fill":"none","stroke":"#ffb600","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M-16335.953 6823.988c.09.632.09 1.174.181 1.807a.6.6 0 0 0 1.174.09v-.271c.09-.542.09-1.174.181-1.717.09-.632.09-1.174.181-1.807a1.944 1.944 0 0 0 0-.723 1.059 1.059 0 0 0-.994-.812.953.953 0 0 0-.9 1.084 1.764 1.764 0 0 0 .09.632 11.519 11.519 0 0 0 .087 1.717zm.723 2.891a.951.951 0 1 0-.09 1.9 1 1 0 0 0 .994-.994.851.851 0 0 0-.904-.906z","data-name":"Path 3463","fill":"#ffb600"}})])])
          )
        }
      }
    